import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ProductPrice, { ProductPriceStyles } from "@insite/content-library/Components/ProductPrice";
import Typography from "@insite/mobius/Typography";
import CENProductPriceCustomPDP from "@tCentro/Components/CENProductPriceCustomPDP";
import { COLORS, TYPOGRAPHY } from "@tCentro/theme/design";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

type OwnProps = WidgetProps & HasProductContext & ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: ApplicationState) => ({
    productSettings: getSettingsCollection(state).productSettings,
});

export interface ProductDetailsPriceStyles {
    productPrice?: ProductPriceStyles;
}

export const priceStyles: ProductDetailsPriceStyles = {
    productPrice: {
        price: {
            priceText: { size: 26 },
            unitOfMeasureText: { size: 26 },
        },
    },
};

const styles = priceStyles;

const ProductDetailsPrice: React.FC<OwnProps> = ({ productContext, productSettings }) => {
    if (productContext?.product?.isVariantParent) {
        return (
            <>
                <Typography
                    as="p"
                    css={css`
                        margin: 18px 0px 18px 6px;
                        color: ${COLORS.text.mineShaft};
                        font-family: ${TYPOGRAPHY.fontFamily.title};
                        font-size: ${TYPOGRAPHY.size.large};
                        font-weight: ${TYPOGRAPHY.weight.mediumbold};
                        line-height: ${TYPOGRAPHY.lineHeight.base};
                        text-align: left;
                    `}
                >
                    {siteMessage("Parent_Variant_PricingMessage")}
                </Typography>
            </>
        );
    }
    return (
        <CENProductPriceCustomPDP
            product={productContext}
            showLabel={false}
            showSavings={true}
            showSavingsAmount={productSettings.showSavingsAmount}
            showSavingsPercent={productSettings.showSavingsPercent}
            extendedStyles={styles.productPrice}
        />
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withProductContext(ProductDetailsPrice)),
    definition: {
        displayName: "Price",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
